module.exports = __webpack_public_path__ + "media/images/ui__infoBoxSmall-775f5c7e5c686185fd5afb5eabf3ec60.png";